import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/operated/footerOperation',
    owner: '/home',
    authority: 'footerOperationList',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/operated/footerOperation/new',
    owner: '/home',
    authority: 'footerOperationAdd',
    component: Loadable({
      loader: () => import('../edit/new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/operated/footerOperation/:id/edit',
    owner: '/home',
    authority: 'footerOperationEdit',
    component: Loadable({
      loader: () => import('../edit/mod'),
      loading: () => <RouteLoading />
    })
  }

];